// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nc6IqNs8MzxoXL {
  padding: 8px;
  border-radius: 5px;
  background: linear-gradient(225deg, var(--ds-background-discovery, #f3f0ff) 0%, var(--ds-background-discovery, #e9f2ff) 100%);
}
.nc6IqNs8MzxoXL .LlqfmVtnhJGsH4 {
  margin: 8px 0 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
}
.nc6IqNs8MzxoXL .V30fqYQntha9X7 {
  align-self: stretch;
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PremiumBanner": `nc6IqNs8MzxoXL`,
	"title": `LlqfmVtnhJGsH4`,
	"description": `V30fqYQntha9X7`
};
export default ___CSS_LOADER_EXPORT___;
